"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledCard = (0, _styledComponents.default)(_fiverReactUiComponents.Card)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: ", ";\n  padding: 1rem;\n\n  @media (min-width: ", ") {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n"])), function (p) {
  return p.theme.borderRadius;
}, function (props) {
  return props.theme.screenWidthXxs;
});

var Wrapper = function Wrapper(_ref) {
  var children = _ref.children,
      minHeight = _ref.minHeight;
  return /*#__PURE__*/_react.default.createElement(StyledCard, {
    minHeight: minHeight
  }, children);
};

var _default = Wrapper;
exports.default = _default;